import {useIsCustomWidth} from '@jobseeker/lotus/hooks';
import {WhiteCrossOutlined} from '@jobseeker/lotus/icons';
import {Box, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {SyntheticEvent, useEffect, useRef} from 'react';
import IconButton from '@mui/material/IconButton';

type Props = {
  onClose: (e: React.SyntheticEvent) => void;
  info: React.ReactNode;
};

export default function InfoBanner({info, onClose}: Props) {
  const banner = useRef<HTMLElement>();
  const isXXS = useIsCustomWidth('xs');
  const handleClose = (e: SyntheticEvent) => {
    const event = new CustomEvent('banner_height', {detail: {height: 0}});
    document.dispatchEvent(event);
    onClose(e);
  };

  useEffect(() => {
    const height = banner.current?.clientHeight;
    const event = new CustomEvent('banner_height', {detail: {height}});
    document.dispatchEvent(event);
  }, []);

  return (
    <Box
      component={'div'}
      ref={banner}
      sx={{
        background: 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
        color: '#FFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          maxWidth: {xxs: 240, xs: 300, sm: 'max-content'},
        }}
      >
        <Typography
          sx={{
            fontSize: {xxs: '10px', xs: '12px', sm: '14px'},
            fontWeight: 500,
            py: 1.75,
            textAlign: 'center',
          }}
        >
          {info}
        </Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          right: '16px',
          display: 'flex',
          cursor: 'pointer',
          color: '#FFF',
          alignItems: 'center',
        }}
        onClick={handleClose}
      >
        <IconButton aria-label="close" onClick={handleClose}>
          <Image
            src={WhiteCrossOutlined}
            alt={'CrossOutlined'}
            width={isXXS ? 12 : 18}
            height={isXXS ? 12 : 18}
            objectFit="cover"
          />
        </IconButton>
      </Box>
    </Box>
  );
}
